import React from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';
import FormControl from './FormControl';
import TimePicker from 'react-time-picker';
import moment from 'moment-timezone';
import i18n from '../../../i18n/translate';

export default class TimePickerControl extends FormControl{
  static propTypes = {
    children: PropTypes.any,
    onChange: PropTypes.func,
    onValueChange: PropTypes.func,
    dataValue: PropTypes.any,
    required: PropTypes.bool,
    disablePicker: PropTypes.bool,
    placeholder: PropTypes.string,
    valueOverride: PropTypes.bool
  };

  static defaultProps = Object.assign({}, FormControl.defaultProps, {
    disablePicker: false
  });

  constructor(props){
    super(props);
    this.state = { value: props.dataValue || '' };
  }

  componentWillReceiveProps(newProps){
    if(newProps.valueOverride && this.props.dataValue !== newProps.dataValue){
      if (this.state.value !== newProps.dataValue) {
        this.onChange(newProps.dataValue, true);
      }
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    return !(this.props.closeOnSelect && this.state.value === nextState.value);
  }

  onBlur = (event) => {
    if (ReactDOM.findDOMNode(this.picker).contains(event.relatedTarget)) {
      return;
    }
    if (typeof this.props.onBlur === 'function'){
      this.props.onBlur(this.state.value);
    }
    this.checkError();
  };

  resetInputs = (value) => {
    if(!value) {
      const pickerEl = ReactDOM.findDOMNode(this.picker);
      setTimeout(() => {
        if(pickerEl) {
          pickerEl.querySelector('.react-time-picker__inputGroup__hour').value = '';
          pickerEl.querySelector('.react-time-picker__inputGroup__minute').value = '';
          pickerEl.querySelector('.react-time-picker__inputGroup__amPm').value = '';
        }
      });
    }
  }

  onChange = (value, skipValueChange) => {
    if (typeof this.props.onValueChange === 'function' && !skipValueChange){
      this.props.onValueChange({ [this.props.name]: value });
    }
    if (typeof this.props.onChange === 'function'){
      this.props.onChange(value);
    }
    this.setState({ value: value }, this.resetInputs(value));
  }

  isValid = () => {
    let input = ReactDOM.findDOMNode(this.picker).querySelector('input');
    if (input) {
      if(!this.props.required && !input.value){
        return true;
      }
      const momentized = moment(input.value, "h:mm a");
      return input.validity.valid && moment(momentized).isValid();
    }
  }

  checkError = () => {
    var message = null;
    var node = ReactDOM.findDOMNode(this.input);
    if(node) {
      if(node.validity.valueMissing && this.props.required) {
        message = i18n.t("This field is required");
      } else if (!node.validity.valid) {
        message = i18n.t("The date you entered is invalid");
      } else if (!node.value && !this.props.required) {
        message = null;
      }
    }
    if (typeof this.props.setError === 'function') {
      this.props.setError(!this.isValid(), message);
    }
  }

  onRef = (picker) => {
    this.picker = picker;
    if (this.picker) {
      const pickerEl = ReactDOM.findDOMNode(this.picker);
      this.input = pickerEl.querySelector('input');
    }
  }

  render(){
    const { readOnly, setError, name, valueOverride, disablePicker, ...props } = this.props;  // eslint-disable-line no-unused-vars
    return (
      <React.Fragment>
        <TimePicker
          {...props}
          dateFormat={false}
          disabled={disablePicker}
          displayNumbersOutside={true}
          onBlur={this.onBlur}
          onChange={this.onChange}
          ref={this.onRef}
          renderNumbers={true}
          value={this.state.value}
        />
        <input type="hidden" id={`${name}_formatted`} value={this.state.value} name={name} />
      </React.Fragment>);
  }
}
